var canvas, canvas1, canvas2,basecolor,currentImage, text, newText, zoom, cWidth = 1000, cHeight = 700,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 210, sizeB1H = 468;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


$(document).ready(function() {

  currentImage = null; 

  function loadImage(url) {
    if (currentImage) {
      canvas2.remove(currentImage);
    }
    fabric.Image.fromURL(url, function(img) {
      img.set({
        left: halfWidth,
        top: halfHeight,
        selectable: false
      });
      // img.scale(.6);
      canvas2.add(img);
      currentImage = img; 
      img.sendToBack();
      // window['text1Page'].bringToFront();
      canvas2.renderAll();
    }, { crossOrigin: 'anonymous' });
  }

  var defaultUrl = $('#base1 img').attr('data-src');
  if(defaultUrl) {
    loadImage(defaultUrl);
  }

  
  // On style change
  jQuery(document).on('change', 'input[name="Style"]', function(e) {
    var selectedVal = $(this).val();

    if (selectedVal === 'Black Base Landscape (Big Size: Height 5.5 Width 8 inches)') {
      var blackUrl = $('#base1 img').attr('data-src');
      loadImage(blackUrl);
    } else {
      var woodenUrl = $('#base2 img').attr('data-src');
      loadImage(woodenUrl);
    }
  });

});


let frameImg = document.querySelector("#lamp_flower");
let simpleImage = new fabric.Image(frameImg, {
  left: 0,   
  top: 0,
  selectable: false
});
let hajjMuba = document.querySelector("#hajj_mubarik");
let hajjMubarik = new fabric.Image(hajjMuba, {
  left: 567,   
  top: 113,
  scaleX: 0.24,
  scaleY: 0.24,
  selectable: false
});
let umraMuba = document.querySelector("#umrah_mubarik");
let umrahMubarik = new fabric.Image(umraMuba, {
  left: 567,   
  top: 113,
  scaleX: 0.24,
  scaleY: 0.24,
  selectable: false
});

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: 1000,
  height: 700
});

window['canvas2'].add(simpleImage);
window['canvas2'].add(hajjMubarik);
window['canvas2'].add(umrahMubarik);


$(document).ready(function () {
  // Initially show only the selected one
  if ($('#select-title').val() === 'Hajj') {
    umrahMubarik.set({ opacity: 0 });
    hajjMubarik.set({ opacity: 1 });
  } else {
    hajjMubarik.set({ opacity: 0 });
    umrahMubarik.set({ opacity: 1 });
  }
  canvas2.renderAll();

  // On dropdown change
  $('#select-title').on('change', function () {
    const selected = $(this).val();

    if (selected === 'Hajj') {
      umrahMubarik.set({ opacity: 0 });
      hajjMubarik.set({ opacity: 1 });
    } else if (selected === 'Umrah') {
      hajjMubarik.set({ opacity: 0 });
      umrahMubarik.set({ opacity: 1 });
    }

    canvas2.renderAll();
  });
});



addModify(window['canvas2']);

// let canvas2 = document.getElementById("canvas2").style.backgroundImage = jQuery('#page02').attr('data-canvas');

vLine = new fabric.Line([cWidth / 2, 0, cWidth / 2, cWidth*2],{
  stroke: 'black',
  strokeWidth: 1,
  selectable: false,
  evented: false
});
leftMarker = new fabric.Text('Left',{
  left: 20,
  top: 13,
  fontSize: 15,
  fontFamily: 'Arial',
  fill: 'red',
  selectable: false,
  evented: false
});
rightMarker = new fabric.Text('Right',{
  left: cWidth - 27,
  top: 13,
  fontSize: 15,
  fontFamily: 'Arial',
  fill: 'blue',
  selectable: false,
  evented: false
});



let currentImgInstance = null; 


document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const defaultImgUrl = document.getElementById('image_preview')?.src;
    const canvas = window['canvas2'];
    const placeholder = window['placeholderimg1'];

    if (defaultImgUrl && canvas && placeholder) {
      fabric.Image.fromURL(defaultImgUrl, function (imgInstance) {
        imgInstance.set({
          left: placeholder.left,
          top: placeholder.top,
          scaleX: placeholder.width / imgInstance.width,
          scaleY: placeholder.height / imgInstance.height,
          selectable: false
        });

        imgInstance.bringToFront();
        canvas.add(imgInstance);
        canvas.renderAll();

        currentImgInstance = imgInstance;
      });
    }
  }, 300); // Wait for canvas and elements to be ready
});


window['text1Page'] = new fabric.Text('check',{
  left: 685,
  top: 260,
  fontSize: 33,
  fontFamily: 'Elicit Script',
  fill: '#fff',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Umrah Mubarak') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

// Fit text within a specific width
function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 33; // Start from larger size
  textObj.set({ fontSize });

  // Repeatedly shrink font until it fits
  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// Update text live and auto-fit width
document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 230); // ← adjust width as needed
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});






var maxWidth = 180;
var maxHeight = 150;


window['text2Page'] = new fabric.Text('check',{
  left: 685,
  top: 475,
  width: 180,
  fontSize: 16,
  fontFamily: 'Lora',
  textAlign: 'center',
  isWrapping: true,
  fill: '#fff'
});



window['canvas2'].add(window['text2Page']);

var minFontSize = 10;
var maxFontSize = 16;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'May this spiritual journey\ncleanse your soul and draw\nyou nearer to Allah.') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text2Page'].set({
    text: input
  });
  //fitTextToWidth(window['text2Page'], maxWidth);
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}






window['text3Page'] = new fabric.Text('The Malik Family',{
  left: 685,
  top: 420,
  fontSize: 28,
  fontFamily: 'Elicit Script',
  fill: '#fff',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName3 = window['text3Page'].fontFamily;
jQuery('.choose_font4').val("'" + fontName3 + "'").trigger('change');

window['canvas2'].add(window['text3Page']);


document.getElementById('text_3').addEventListener('focus', function () {
  if (window['text3Page'].text === 'The Malik Family') {
    window['text3Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth2(textObj, maxWidth) {
  let fontSize = 28; // Start from larger size
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// Update text live and auto-fit width
document.getElementById('text_3').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text3Page'].set('text', newText);
  fitTextToWidth2(window['text3Page'], 210); // ← adjust width as needed
  window['text3Page'].bringToFront();
  window['canvas2'].renderAll();
});



var maxWidth4 = 100;
var maxHeight4 = 150;

var para = "DHUL HIJJAH 1446\nMAY 2025" ;

window['text4Page'] = new fabric.Text(para,{
  left: 235,
  top: 520,
  width: 100,
  fontSize: 14,
  fontFamily: 'Arial',
  textAlign: 'center',
  isWrapping: true,
  fill: '#fff'
});


window['canvas2'].add(window['text4Page']);

var minFontSize4 = 10;
var maxFontSize4 = 14;

// Clear text on input focus if default
document.getElementById('text_4').addEventListener('focus', function () {
  if (window['text4Page'].text === 'DHUL HIJJAH 1446\nMAY 2025') {
    window['text4Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize4;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize4
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_4').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text4Page'].set({
    text: input
  });
  //fitTextToWidth(window['text4Page'], maxWidth4);
  fitTextToBox4(window['text4Page'], maxWidth4, maxHeight4);
});

function fitTextToBox4(textObj, maxWidth4, maxHeight4) {
  let fontSize = maxFontSize4;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth4 || textObj.height > maxHeight4;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize4) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  // jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}


document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});


jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToWidth(window['text1Page'], 230);
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
  fitTextToWidth2(window['text3Page'], 210);
  fitTextToBox4(window['text4Page'], maxWidth4, maxHeight4);
});


function showExtras(canvas){
  vLine.set({
    visible: true
  });
  leftMarker.set({
    visible: true
  });
  rightMarker.set({
    visible: true
  });
  canvas.renderAll();
}

function hideExtras(canvas){
  vLine.set({
    visible: false
  });
  leftMarker.set({
    visible: false
  });
  rightMarker.set({
    visible: false
  });
  canvas.renderAll();
}



jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Umrah Mubarak');
  window['text2Page'].set('text','May this spiritual journey\ncleanse your soul and draw\nyou nearer to Allah.');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=lamaPao; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});



/* fetch Call */
var size,thumbnail;
var loadedObject,enterTitle,Font1,enterFamily,Font2,enterQuote,enterDate,additionalInfo,frameColor, wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    canvas.remove(currentImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    enterTitle = jQuery('.enter_title input').val();
    Font1 = jQuery('.Font1 option:selected').val();
    enterFamily = jQuery('.enter_family input').val();
    Font2 = jQuery('.Font2 option:selected').val();
    enterQuote = jQuery('.enter_quotes textarea').val();
    enterDate = jQuery('.enter_date textarea').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    frameColor = jQuery('.frameColorBox').val();
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#enterTitle').val(enterTitle);
      jQuery('#chooseFont1').val(Font1);
      jQuery('#enterDate').val(enterDate);
      jQuery('#enterFamily').val(enterFamily);
      jQuery('#enterQuote').val(enterQuote);
      jQuery('#chooseFont2').val(Font2);
      jQuery('#addInfo').val(additionalInfo);
      jQuery('#selected_frameColor').val(frameColor);
      console.log('Server response:', data);
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(currentImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}


function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}